import React, {forwardRef, CSSProperties} from 'react';

import styles from './Action.module.scss';
import ClassNames from "../ClassNames";


export interface ActionProps extends React.HTMLAttributes<HTMLButtonElement> {
    active?: {
        fill: string;
        background: string;
    };
    cursor?: CSSProperties['cursor'];
}

export const Action = forwardRef<HTMLButtonElement, ActionProps>(
    ({active, className, cursor, style, ...props}, ref) => {
        return (
            <button
                ref={ref}
                {...props}
                className={ClassNames(styles.Action, className)}
                tabIndex={0}
                style={
                    {
                        ...style,
                        cursor,
                        '--fill': active?.fill,
                        '--background': active?.background,
                    } as CSSProperties
                }
            />
        );
    }
);
